import SeriesSelected from './SeriesSelectedTable';

export default SeriesSelected;
